<div class="hero" [ngClass]="bannerClass">
  <ng-container *ngIf="hasBanner; else staticBanner">
    <div class="hero-photo-wrap">
      <picture>
        <source media="(min-width: 768px)" [attr.srcset]="bannerImageUrl" />
        <img class="hero-photo" [src]="bannerImageMobileUrl" [alt]="bannerImageAltText" />
      </picture>
    </div>

    <div class="container banner-content">
      <div class="row">
        <div class="col-12 col-md-10 col-lg-8 ps-4 py-4">
          <div class="main-text">Making Your Smile Come to Life!</div>
          <div class="sub-text mt-2 mt-lg-4">Simple easy to understand benefits to meet your dental needs.</div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #staticBanner>
    <div class="hero-photo-wrap">
      <picture>
        <source media="(min-width: 768px)" srcset="assets/images/Banner-image2x.png" />
        <img class="hero-photo" src="assets/images/Banner-image1x.png" alt="hero" />
      </picture>
    </div>
    <div class="container banner-content">
      <div class="row">
        <div class="col-12 col-md-6 ps-4 py-4">
          <div class="main-text">Making Your Smile Come to Life!</div>
          <div class="sub-text mt-2 mt-lg-4">Simple easy to understand benefits to meet your dental needs.</div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
